var map = {
	"./de-de/img_logo.png": "a8e0",
	"./en-gb/img_logo.png": "acaf",
	"./en-us/img_logo.png": "59c2",
	"./es-es/img_logo.png": "ba45",
	"./es-mx/img_logo.png": "0f70",
	"./fr-ca/img_logo.png": "b3ab",
	"./fr-fr/img_logo.png": "42ca",
	"./it-it/img_logo.png": "71af",
	"./ja-jp/img_logo.png": "5ea5",
	"./pt-br/img_logo.png": "76cd",
	"./zh-tw/img_logo.png": "6a01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e0d";